const homeRoot = 'home';

const ongoingRequestsRoot = 'ongoing';
const fcRequestsRoot = `${ongoingRequestsRoot}/fc-requests`;
const fiRequestsRoot = `${ongoingRequestsRoot}/fi-requests`;
const userManagementRoot = 'user-management';
const adminRoot = 'admin';
const reportingRoot = 'reporting';

export const homeRouteNames = {
  home: homeRoot,
}

export const ongoingRequestsNames = {
  ongoingRequests: ongoingRequestsRoot,
};

export const fcRequestsRouteNames = {
  fcRequests: 'fc-requests',
  dispatchFcRequest: 'dispatch',
  newSvRequest: 'sv-new',
  newFcRequest: 'new',
  editFcRequest: 'edit',
  instructFcRequest: 'instruct',
  commentFcRequest: 'comment',
  closeFcRequest: 'close',
  viewFcRequest: 'view',
};

export const fiRequestsRouteNames = {
  fiRequests: 'fi-requests',
  dispatchFiRequest: 'dispatch',
  newFiRequest: 'new',
  editFiRequest: 'edit',
  instructFiRequest: 'instruct',
  commentFiRequest: 'comment',
  validatedFiManagerFiRequest: 'fi-manager-validation',
  closeFiRequest: 'close',
  viewFiRequest: 'view',
};

export const reportingRouteNames = {
  reporting: reportingRoot,
  fcReporting: 'fc-reporting',
  fiReporting: 'fi-reporting',
  scopeVariationReporting: 'scope-variation-reporting',
}

export const userManagementRouteNames = {
  userManagement: userManagementRoot,
};

export const adminRouteNames = {
  admin: adminRoot,
};

export const globalRouteNames = {
  root: '/',
  home: homeRoot,

  ongoingRequests: ongoingRequestsRoot,
  fcRequests: fcRequestsRoot,
  dispatchFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.dispatchFcRequest}/:id`,
  newFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.newFcRequest}`,
  newSvRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.newSvRequest}`,
  editFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.editFcRequest}/:id`,
  instructFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.instructFcRequest}/:id`,
  commentFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.commentFcRequest}/:id`,
  closeFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.closeFcRequest}/:id`,
  viewFcRequest: `${fcRequestsRoot}/${fcRequestsRouteNames.viewFcRequest}/:id`,
  fiRequests: fiRequestsRoot,
  dispatchFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.dispatchFiRequest}/:id`,
  newFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.newFiRequest}`,
  editFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.editFiRequest}/:id`,
  instructFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.instructFiRequest}/:id`,
  commentFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.commentFiRequest}/:id`,
  closeFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.closeFiRequest}/:id`,
  viewFiRequest: `${fiRequestsRoot}/${fiRequestsRouteNames.viewFiRequest}/:id`,

  reporting: reportingRoot,
  fcReporting: `${reportingRoot}/${reportingRouteNames.fcReporting}`,
  fiReporting: `${reportingRoot}/${reportingRouteNames.fiReporting}`,

  invoiceReporting: `${reportingRoot}/${reportingRouteNames.fiReporting}`,
  scopeVariationReporting: `${reportingRoot}/${reportingRouteNames.scopeVariationReporting}`,
  userManagement: userManagementRoot,
  admin: adminRoot,
};
